import React from "react";
import { Icon, Text, toast, Tooltip } from "@telia/teddy";
import { copyToClipboard } from "../../../../../utils/copyToClipboard";
import cn from "classnames";

interface Props {
    value: string | null | undefined;
    ariaLabel: string;
    toastMessage: string;
    tooltipLabel?: string;
}

const CopyButton = ({ value, ariaLabel, toastMessage, tooltipLabel }: Props) => {
    const button = (
        <button
            type="button"
            className={cn("order-detail__summary-copy-button", { "order-detail__summary-copy-button--hidden": !value })}
            onClick={() => {
                if (!value) {
                    return;
                }
                copyToClipboard(value);
                toast.success(toastMessage);
            }}
            aria-label={ariaLabel}
            disabled={!value}
        >
            <Icon name="copy" size="sm" aria-hidden="true" focusable="false" />
        </button>
    );

    if (!tooltipLabel) {
        return button;
    }

    return (
        <Tooltip>
            <Tooltip.Trigger asChild>{button}</Tooltip.Trigger>
            <Tooltip.Content>
                <Text>{tooltipLabel}</Text>
            </Tooltip.Content>
        </Tooltip>
    );
};

export default CopyButton;
